var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.3 13.7l-6-6c-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L2.4 7l5.3 5.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3z"}));
}

ChevronLeft.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
